








import store from '@/store';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

@Component
export default class LetterTypeSelector extends Vue {
    firstSelected = false;
    secondSelected = false;
    allSelected = true;
    firstButtonTxt = '';
    secondButtonTxt = '';
    thirdButtonTxt = '';
    @Prop() mode?: string;
    @Watch('mode')
    onModeChanged(newVal: string, oldVal: string){
        this.setButtonsText();
        
    }
    @Prop() counts?: any;
    @Watch('counts',{deep:true})
    onCountsChange(n: any,o: any){
        this.setButtonsText();
    }
    unSelectAll(){
        this.allSelected = false;
        this.secondSelected = false;
        this.firstSelected = false;
    }
    select(p: number){
        this.unSelectAll();
        if(p === 1){
            this.firstSelected = true;
            if(this.mode === 'received')
                this.$emit('letter-type-changed',"notForwarded");
            else if(this.mode === 'drafts')
                this.$emit('letter-type-changed',"sent");
        }else if(p === 2){
            this.secondSelected = true;
            if(this.mode === 'received')
                this.$emit('letter-type-changed','notRead');
            else if(this.mode === 'drafts')
                this.$emit('letter-type-changed',"notSent");
        }else{
            this.allSelected = true;
             this.$emit('letter-type-changed',"all");
        }
        store.state.eventHub.$emit('letter-type-changed');
    }
    created(){
        this.setButtonsText();
    }
    decreaseNotRead(){
        if(this.counts.notRead )
            this.counts.notRead = this.counts.notRead -1;
    }
    setButtonsText(){
        if(this.mode === 'received'){
            this.firstButtonTxt = `ارجاع نشده (${this.counts.notForwarded})`;
            this.secondButtonTxt = `خوانده نشده (${this.counts.notRead})`;
            this.thirdButtonTxt = `همه (${this.counts.all})`;

        }
        else if(this.mode === 'drafts'){
            this.firstButtonTxt = `ارسال شده (${this.counts.draftSent})`;
            this.secondButtonTxt = `ارسال نشده (${this.counts.draftNotSent})`;
            this.thirdButtonTxt = `همه (${this.counts.all})`;
        }
    }

    selectAllMode(){
        this.select(3);
    }
    selectNotSentMode(){
        this.select(2);
    }
}
